import * as R from 'ramda'
import React from 'react'
import styled from 'styled-components'

import StickyBox from '../../components/StickyBox'
import { useMq } from '../../hooks'
import mq from '../../utils/mediaQuery'

const DonationListContainer = styled.div`
  width: 100%;
  ${mq.tabletMobile} {
    order: 1;
  }
`
const StyledStickyBox = styled(StickyBox)`
  width: 33.3333333%;
  padding: 0 12px;
  float: right;
`

const DonationStickySidebar = ({ offsetTop, children, className }) => {
  const { isMatch } = useMq({ minWidth: 1200 })

  if (R.isNil(isMatch)) return null

  return isMatch ? (
    <StyledStickyBox offsetTop={offsetTop} className={className}>
      {children}
    </StyledStickyBox>
  ) : (
    <DonationListContainer className={className}>
      {children}
    </DonationListContainer>
  )
}

export default DonationStickySidebar
